module.exports = __webpack_public_path__ + "fonts/font.05de134.woff";